/* eslint-disable @typescript-eslint/no-explicit-any */
import { Paginator } from '@orange-marmalade/paginate-this'
import { recordProps } from '@orange-marmalade/paginate-this/dist/pageInfoTranslator'
import Immutable from 'immutable'
import { PagePropSelectors } from '../../typings/selectors'

/**
 * These are paginate data slices,
 * that have been to serialize from paginator data with immutability,
 * for using of them in components state/props
 *
 * @param {Object} paginator
 * @return {Object} selectors
 */
export default function select(paginator: Paginator): PagePropSelectors {
    const tabulateByState: PagePropSelectors['tabulateByState'] = () => ({
        results: paginator.get('results').toJS(),
        ids: paginator
            .get('results')
            .map((r: Immutable.Set<any>) => r.get(recordProps().identifier)),
        isLoading: paginator.get('isLoading'),
        stale: paginator.get('stale')
    })

    const tabulateList: PagePropSelectors['tabulateList'] = () => ({
        initialized: paginator.get('initialized'),
        results: paginator.get('results').toJS(),
        ids: paginator
            .get('results')
            .map((r: Immutable.Set<any>) => r.get(recordProps().identifier)),
        isLoading: paginator.get('isLoading'),
        isAdding: paginator.get('isAdding')
    })

    const filterData: PagePropSelectors['filterData'] = () => ({
        isLoading: paginator.get('isLoading'),
        stale: paginator.get('stale'),
        filters: paginator.get('filters').toJS(),
        sort: paginator.get('sort'),
        sortReverse: paginator.get('sortReverse')
    })

    const lazyDrive: PagePropSelectors['lazyDrive'] = () => ({
        isLoading: paginator.get('isLoading'),
        isAdding: paginator.get('isAdding')
    })

    return {
        tabulateByState,
        tabulateList,
        filterData,
        lazyDrive
    }
}
